import { cn } from '@/lib/utils';
import type { DashboardLayoutProps } from '../types';

export function DashboardLayout({ header, children, fullWidth }: DashboardLayoutProps) {
  return (
    <div className="flex flex-col h-full w-full">
      {header ? (
        <header className="sticky top-0 z-10 border-b border-border bg-background shrink-0">
          <div className="flex h-14 items-center">
            <div className={cn(fullWidth ? 'w-full px-6' : 'container mx-auto px-6')}>
              {header}
            </div>
          </div>
        </header>
      ) : null}
      <main className="flex-1 overflow-y-auto overflow-x-hidden bg-background [scrollbar-gutter:stable]">
        <div className={cn('py-6 min-w-0', fullWidth ? 'px-6' : 'container mx-auto px-6')}>
          {children}
        </div>
      </main>
    </div>
  );
}
